import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';

export default function FilterButton({ onClick, className = '' }) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-center gap-1.5 h-8 px-3 bg-white border border-mono-200 rounded-lg text-xs font-medium text-mono-900 hover:bg-mono-50 transition-colors ${className}`}
    >
      <Icon name="filter" size={16} />
      {t('common.filter')}
    </button>
  );
}
